import { render, staticRenderFns } from "./Producttypes.vue?vue&type=template&id=3eaaaad0&"
import script from "./Producttypes.vue?vue&type=script&lang=js&"
export * from "./Producttypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports